module.exports = __webpack_public_path__ + "static/media/europe1.fb21173c.png";